import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { store } from '../store';
import { Provider } from 'react-redux';

import { HomePage } from '../Components/HomePage';
import { history } from '../helpers/history';
import '../assets/css/style.css';
import { BuyerLogin, SellerLogin, AffiliatorLogin } from './Login';
import { SellerRegistration } from './Registration/SellerRegistration';
import { SellerRegistrationForm } from './Registration/SellerRegistrationForm';
import { BuyerRegistration } from './Registration/BuyerRegistration';
import { BuyerRegistrationForm } from './Registration/BuyerRegistrationForm';
import { AffiliatorRegistrationForm } from './Registration/AffiliatorRegistrationFrom';
import { ForgetPassword } from './ResetPassword/ForgetPassword';
import { ResetPasswordMessage } from './ResetPassword/ResetPasswordMessage';
import { Categories } from './Categories';
import { CategoriesDetails } from './CategoriesDetails/CategoriesDetails';
import { Purchase } from './Puarchase';
import { BuyerDashboard } from './Dashboard/BuyerDashboard';
import { SellerDashboard } from './Dashboard/SellerDashboard';
import { SearchResult } from './Search/SearchResult';
import { RequestBulletin } from './Request/RequestBulletin';

import { SellerTransaction } from './Transactions/SellerTransaction';
import { SellerEstimate } from './Transactions/SellerEstimate';
import { EditProfileNav } from './Profile/EditProfileNav';
import { IntroductoryText } from './Profile/IntroductoryText';
import { Portfolio } from './Profile/Portfolio';
import { ProfileView } from './Profile/ProfileView';
import { PortfolioAll } from './Profile/PortfolioAll';
import { SellerComCan } from './Transactions/SellerComCan';
import { BuyerComCan } from './Transactions/BuyerComCan';
import { BuyerTransaction } from './Transactions/BuyerTransaction';
import { BuyerEstimate } from './Transactions/BuyerEstimate';
import { BuyerEstimateAlt } from './Transactions/BuyerEstimateAlt';
import { SellerBuyerComCan } from './Transactions/SellerBuyerComCam';
import { SellerBuyerTransaction } from './Transactions/SellerBuyerTransaction';
import { SellerBuyerEstimate } from './Transactions/SellerBuyerEstimate';
import { SellerBuyerEstimateAlt } from './Transactions/SellerBuyerEstimateAlt';

import { ProductUpload } from './ProductUpload';

import { ServiceList } from './ProductUpload/ServiceList';
// import { PurchaseProducts } from './Affiliator/PurchaseProducts';
import { RequestHome } from './Request/RequestHome';
import { BuyerRequestHome } from './Request/BuyerRequestHome';
import { PostRequestBuyer } from './Request/PostRequestBuyer';
import { SellerBuyerRequestHome } from './Request/SellerBuyerRequestHome';
import { SellerPostRequestBuyer } from './Request/SellerPostRequestBuyer';
import { Followers } from './Followers/Followers';
import { FollowersBuyer } from './Followers/FollowersBuyer';
import { SellerFollowersBuyer } from './Followers/SellerFollowersBuyer';
import { Configuration } from './Configuration/Configuration';
import { ConfigurationBuyer } from './Configuration/ConfigurationBuyer';
import { MyPoints } from './MyPoints/MyPoints';

import { AffiliatorDashboard } from './Dashboard/AffiliatorDashboard';
import { RegistrationSuccessMessage } from './Registration/RegistrationSucces';
import { RequestList } from './Request/RequestList';
import { PostRequest } from './Request/PostRequest';
import { About } from './Common/About';
import { FAQ } from './Common/FAQ';
import { CreateServiceLink, CreateLink } from './Affiliator';
import { AffiliateManagement } from './Affiliator/AffiliateManagement';
import { SalesManagement } from './Affiliator/SalesManagement';
// import { AffiliatorProfile } from './Affiliator/AffiliatorProfile';
import { AffiliatorChangePasswod } from './ChangePassword/AffiliatorChangePassword';
import { ReferralLink } from './Affiliator/ReferralLink';
import { SellerFavorites } from './Seller/SellerFavorites';
import { MLMTree } from './Affiliator/AffiliatorTree';
import { SellerDirectMessageList } from './DirectMessage/SellerDirectMessageList';
import { SellerDirectMessage } from './DirectMessage/SellerDirectMessage';
import { BuyerDirectMessage } from './DirectMessage/BuyerDirectMessage';
import { BuyerDirectMessageList } from './DirectMessage/BuyerDirectMessageList';
import { BuyerFavorites } from './Buyer/BuyerFavorites';
import { SellerChangePasswod } from './ChangePassword';
import { AffiliatorIndividualService } from './Affiliator/AffilitorIndividualService';
import { SellerBuyerDirectMessageList } from './DirectMessage/SellerBuyerDirectMessageList';
import { SellerBuyerDirectMessage } from './DirectMessage/SellerBuyerDirectMessage';
import { BuyerChangePasswod } from './ChangePassword/BuyerChangePassword';
import { AffiliatorBuyerComCan } from './Transactions/AffiliatorBuyerComCan';
import { AffiliatorBuyerEstimate } from './Transactions/AffiliatorBuyerEstimate';
import { AffiliatorBuyerEstimateAlt } from './Transactions/AffiliatorBuyerEstimateAlt';
import { AffiliatorBuyerTransaction } from './Transactions/AffiliatorBuyerTransaction';
import { AffiliatorBuyerRequestHome } from './Request/AffiliatorBuyerRequestHome';
import { AffiliatorPostRequestBuyer } from './Request/AffiliatorPostRequestBuyer';
import { AffiliatorFollowersBuyer } from './Followers/AffiliatorFollowersBuyer';
import { AffiliatorMyPoints } from './MyPoints/AffiliatorMyPoints';
import { AffiliatorDirectMessageList } from './DirectMessage/AffiliatorDirectMessageList';
import { AffiliatorDirectMessage } from './DirectMessage/AffilitorDirectMessage';
import { FirstMessageBuyer } from './DirectMessage/FirstMessageBuyer';
import { AffiliatorFavorites } from './Affiliator/AffiliatorFavorites';
import { CategoriesGrid } from './Categories/CategoriesGrid';
import { RequestConfirmation } from './Request/RequestConfirmationPage';
import { BuyerAskEstimation } from './Transactions/BuyerAskEstimation';
import { subCategory } from './Categories/subCategories';
import { RequestDetails } from './Request/RequestDetails';
import { RequestDetailsFromBulletin } from './Request/RequestDetailsFromBulletin';
import { BuyerAskEstimationEdit } from './Transactions/BuyerAskEstimationEdit';
import { EstimateDetails } from './Transactions/EstimateDetails';
import { AffiliatorProductsDetails } from './Affiliator/AffiliatorProductsDetails';
import { AffiliateChildManagement } from './Affiliator/AffiliateChildManagement';
import { RequestDetailsConfirmation } from './Request/RequestDetailsConfirmation';
import { PurchaseList } from './ProductUpload/PurchaseList';
import { ProfileDetails } from './Profile/ProfileDetails';
import { SellerServiceList } from './Profile/SellerServiceList';
import { SellerPortfolioAll } from './Profile/SellerPortfolioAll';
import { RequestDetailsBuyer } from './Request/RequestDetailsBuyer';
import { Sales } from './Seller/Sales';
import { ProductUploadEdit } from './ProductUpload/ProductUploadEdit';
import { AffiliatorRecuitmentBonus } from './Affiliator/AffiliatorRecuitmentBonus';
import { AffiliatorRankingBonus } from './Affiliator/AffiliatorRankingBonus';
import { AffiliatorMLMTree } from './Affiliator/MLMTree';
import { AffiliatorPurchaseList } from './ProductUpload/AffiliatorPurchaseList';
import { RequestDetailsSeller } from './Request/RequestDetailsSeller';
import { RequestDetailsBuyerSeller } from './Request/RequestDetailsBuyerSeller';
import { FirstMessageSellerBuyer } from './DirectMessage/FirstMessageSellerBuyer';
import { FirstMessageSellerAffiliator } from './DirectMessage/FirstMessageAffiliator';
import { RequestDetailsAffiliatorBuyer } from './Request/RequestDetailsAffiliatorBuyer';
import { AffiliatorLotteryBonus } from './Affiliator/AffiliatorLotteryBonus';
import { BuyerProfile } from './Profile/BuyerProfile';
import { AffiliatorProfile } from './Profile/AffiliatorProfile';
import { AllNotification } from './Notification/AllNotification';
import { PurchaseNotification } from './Notification/PurchaseNotification';
import { SystemNotification } from './Notification/SystemNotification';
import { RequestNotification } from './Notification/RequestNotification';
import { RequestDeclineNotification } from './Notification/RequestDeclineNotification';
import { RequestServeNotification } from './Notification/RequestServeNotification';
import { RequestAcceptNotification } from './Notification/RequestAcceptNotification';
import { RequestEstimationNotification } from './Notification/RequestEstimationNotification';
import { RequestCloseNotification } from './Notification/RequestCloseNotification';
import { FollowingNotification } from './Notification/FollowingNotification';
import { ProductUploadConfirmation } from './ProductUpload/ProductUploadConfirmation';
import { ProductUploadConfirmationEdit } from './ProductUpload/ProductUploadConfirmationEdit';
import { HomePageAffiliator } from './HomePage/HomePageAffiliator';
import { BuyerViewProfile } from './Profile/BuyerViewProfile';
import { RequestDetailsBuyerEstimation } from './Request/RequestDetailsBuyerEstimation';
import { Privacy } from './StaticPages/Privacy';
import { TermsConditions } from './StaticPages/TermsConditions';
import { Notilaws } from './StaticPages/Notilaws';
import { TransactionFlow } from './StaticPages/TransactionFlow';
import { ValidMail } from './Login/ValidMail';
import { SystemChat } from './DirectMessage/SystemChat';
import { PortfolioDetails } from './Profile/PortfolioDetails';
import { ContactUs } from './StaticPages/ContactUs';
import { EnterPassword } from './ResetPassword/EnterPassword';
import { AffiliatorApplication } from './Affiliator/AffiliatorApplication';
import { NewThisMonth } from './Affiliator/NewThisMonth';
import { ActiveThisMonth } from './Affiliator/ActiveThisMonth';
// import {withTranslation} from "react-i18next";
// import '../assets/css/dropdown.css';

class App extends Component {
  render() {
    return (
      <div>
        < Provider store={store}>
          <Router history={history}>
            <Switch>
              <Route exact path="/" component={HomePage} />

              <Route path="/aff/:ref_code" component={HomePageAffiliator} />
              <Route path="/affiliator-application" component={AffiliatorApplication} />
              <Route path="/about" component={About} />
              <Route path="/faq" component={FAQ} />
              <Route path="/Privacy-policy" component={Privacy} />
              <Route path="/terms-conditions" component={TermsConditions} />
              <Route path="/laws-regulations" component={Notilaws} />
              <Route path="/transaction-flow" component={TransactionFlow} />
              <Route path="/contact-us" component={ContactUs} />

              {/* SEARCH */}
              <Route path="/search-results/:id" component={SearchResult} />

              {/* <Route exact path="/" component={HomePage} />ß */}
              {/* Login routing */}

              <Route exact path="/login/buyer" component={BuyerLogin} />
              <Route path="/login/seller" component={SellerLogin} />
              <Route path="/login/affiliator" component={AffiliatorLogin} />

              {/*Registration Routing */}

              <Route path="/seller-registration-step-1" component={SellerRegistration} />
              <Route path="/seller-registration-step-2" component={SellerRegistrationForm} />
              <Route path="/buyer-registration-step-1" component={BuyerRegistration} />
              <Route path="/Buyer-registration-step-2" component={BuyerRegistrationForm} />
              <Route path="/affiliator/:name/:ref_code" component={AffiliatorRegistrationForm} />
              <Route path="/registration-success-message" component={RegistrationSuccessMessage} />

              <Route path="/step-1-confirmation" component={ValidMail} />

              {/* Forget Password */}

              <Route exact path="/password-reset" component={ForgetPassword} />
              <Route path="/password-reset/reset-email-sent" component={ResetPasswordMessage} />
              <Route path="/enter-new-password/:code" component={EnterPassword} />

              {/* Categories */}

              <Route path="/categories/:id" component={Categories} />
              <Route path="/sub-categories/:id" component={subCategory} />
              <Route path="/categories-grid" component={CategoriesGrid} />
              <Route path="/categories-details/:id" exact component={CategoriesDetails} />

              {/* Payment */}

              <Route path="/payment" component={Purchase} />

              {/* Buyer DashBoard */}

              <Route path="/buyer-dashboard" component={BuyerDashboard} />
              <Route path="/buyer-direct-message/:id" component={BuyerDirectMessage} />
              <Route path="/buyer-direct-message-list" component={BuyerDirectMessageList} />
              <Route path="/buyer-favorites" component={BuyerFavorites} />
              <Route path="/buyer-change-password" component={BuyerChangePasswod} />
              <Route path="/chat-initiation" component={FirstMessageBuyer} />

              {/* Affiliator DashBoard */}
              {/* <Route path="/:ref_code" component={HomePageAffiliator} /> */}
              <Route path="/affiliator-dashboard" component={AffiliatorDashboard} />
              <Route path="/new-childern-thismonth" component={NewThisMonth} />
              <Route path="/active-childern-thismonth" component={ActiveThisMonth} />
              <Route path="/affiliator-individual-products" component={AffiliatorIndividualService} />
              <Route path="/affiliator-create-service-link" component={CreateServiceLink} />
              <Route path="/affiliator-create-link" component={CreateLink} />
              <Route path="/affiliator-management" component={AffiliateManagement} />
              <Route path="/affiliator-sales-management" component={SalesManagement} />
              <Route path="/affiliator-management-of-child/:id" component={AffiliateChildManagement} />
              {/* <Route path="/affiliator-profile" component={AffiliatorProfile} /> */}
              <Route path="/affiliator-change-password" component={AffiliatorChangePasswod} />
              <Route path="/affiliator-referral-link" component={ReferralLink} />
              <Route path="/affiliator-mlm-tree" component={AffiliatorMLMTree} />
              <Route path="/affiliator-direct-message-list" component={AffiliatorDirectMessageList} />
              <Route path="/affiliator-direct-message/:id" component={AffiliatorDirectMessage} />
              <Route path="/affiliator-favorites" component={AffiliatorFavorites} />
              <Route path="/aff-product-detail-from-link/:id/:id" component={AffiliatorProductsDetails} />
              <Route path="/aff-reqcuitment-bonus" component={AffiliatorRecuitmentBonus} />
              <Route path="/aff-ranking-bonus" component={AffiliatorRankingBonus} />
              <Route path="/aff-lottery-bonus" component={AffiliatorLotteryBonus} />
              <Route path="/affiliator-purchase-list" component={AffiliatorPurchaseList} />
              <Route path="/affiliator-chat-initiation" component={FirstMessageSellerAffiliator} />

              {/* Seller DashBoard */}

              <Route path="/seller-dashboard" component={SellerDashboard} />
              <Route path="/product-upload" component={ProductUpload} />
              <Route path="/product-upload-confirm" component={ProductUploadConfirmation} />
              <Route path="/product-upload-confirm-edit" component={ProductUploadConfirmationEdit} />
              <Route path="/edit-product-upload/:id" component={ProductUploadEdit} />
              <Route path="/service-list" component={ServiceList} />
              <Route path="/purchase-list" component={PurchaseList} />
              <Route path="/seller-favorites" component={SellerFavorites} />
              <Route path="/seller-direct-message-list" component={SellerDirectMessageList} />
              <Route path="/seller-buyer-direct-message-list" component={SellerBuyerDirectMessageList} />
              <Route path="/seller-direct-message" component={SellerDirectMessage} />
              <Route path="/seller-buyer-direct-message" component={SellerBuyerDirectMessage} />
              <Route path="/seller-change-password" component={SellerChangePasswod} />
              <Route path="/sales" component={Sales} />
              <Route path="/seller-chat-initiation" component={FirstMessageSellerBuyer} />

              <Route path="/com-with-sys" component={SystemChat} />

              {/* Seller Transaction */}

              <Route path="/seller-transaction" component={SellerTransaction} />
              <Route path="/seller-estimate" component={SellerEstimate} />
              <Route path="/estimate-details" component={EstimateDetails} />
              <Route path="/seller-complete-cancel" component={SellerComCan} />

              {/* Buyer Transaction */}

              <Route path="/buyer-transaction" component={BuyerTransaction} />
              <Route path="/buyer-estimate" component={BuyerEstimate} />
              <Route path="/buyer-estimate-alt" component={BuyerEstimateAlt} />
              <Route path="/buyer-complete-cancel" component={BuyerComCan} />
              <Route path="/buyer-ask-estimate/:id" component={BuyerAskEstimation} />
              <Route path="/buyer-ask-estimate-edit/:id" component={BuyerAskEstimationEdit} />

              <Route path="/seller-buyer-transaction" component={SellerBuyerTransaction} />
              <Route path="/seller-buyer-estimate" component={SellerBuyerEstimate} />
              <Route path="/seller-buyer-estimate-alt" component={SellerBuyerEstimateAlt} />
              <Route path="/seller-buyer-complete-cancel" component={SellerBuyerComCan} />

              <Route path="/affiliator-buyer-complete-cancel" component={AffiliatorBuyerComCan} />
              <Route path="/affiliator-buyer-estimate" component={AffiliatorBuyerEstimate} />
              <Route path="/affiliator-buyer-estimate-alt" component={AffiliatorBuyerEstimateAlt} />
              <Route path="/affiliator-buyer-transaction" component={AffiliatorBuyerTransaction} />



              {/* edit profile} */}

              <Route path="/seller-edit-profile" component={EditProfileNav} />
              <Route path="/seller-edit-intro" component={IntroductoryText} />
              <Route path="/seller-edit-portfolio" component={Portfolio} />
              <Route path="/my-profile/users/:id" component={ProfileView} />
              <Route path="/buyer-my-profile" component={BuyerProfile} />
              <Route path="/buyer-my-profile-view/users/:id" component={BuyerViewProfile} />
              <Route path="/affiliator-my-profile" component={AffiliatorProfile} />
              <Route path="/my-profile-view/users/:id" component={ProfileDetails} />
              <Route path="/seller-service-list" component={SellerServiceList} />
              <Route path="/my-portfolio" component={PortfolioAll} />
              <Route path="/my-portfolio-view" component={SellerPortfolioAll} />
              <Route path="/portfolio-details/:id" component={PortfolioDetails} />

              {/* Request */}

              <Route path="/request" component={RequestList} />  
              <Route path="/request-bulletin" component={RequestBulletin} />
              <Route path="/post-request" component={PostRequest} />
              <Route path="/request-home" component={RequestHome} />
              <Route path="/request-confirm" component={RequestConfirmation} />
              <Route path="/request-details/:id" component={RequestDetails} />
              <Route path="/request-details-from-bulletin/:id" component={RequestDetailsFromBulletin} />
              <Route path="/request-details-confirm/:id" component={RequestDetailsConfirmation} />

              <Route path="/buyer-request-home" component={BuyerRequestHome} />
              <Route path="/post-request-buyer" component={PostRequestBuyer} />
              <Route path="/buyer-request-details" component={RequestDetailsBuyer} />
              <Route path="/buyer-request-estimation-details" component={RequestDetailsBuyerEstimation} />
              <Route path="/seller-buyer-request-details" component={RequestDetailsBuyerSeller} />

              <Route path="/seller-buyer-request-home" component={SellerBuyerRequestHome} />
              <Route path="/seller-post-request-buyer" component={SellerPostRequestBuyer} />
              <Route path="/seller-request-details" component={RequestDetailsSeller} />

              <Route path="/affiliator-buyer-request-home" component={AffiliatorBuyerRequestHome} />
              <Route path="/affiliator-post-request-buyer" component={AffiliatorPostRequestBuyer} />
              <Route path="/affiliator-request-details" component={RequestDetailsAffiliatorBuyer} />

              {/* notification */}

              <Route path="/all-notification" component={AllNotification} />
              <Route path="/purchase-notification" component={PurchaseNotification} />
              <Route path="/system-notification" component={SystemNotification} />
              <Route path="/request-notification-receive" component={RequestNotification} />
              <Route path="/request-notification-decline" component={RequestDeclineNotification} />
              <Route path="/request-notification-serve" component={RequestServeNotification} />
              <Route path="/request-notification-accept" component={RequestAcceptNotification} />
              <Route path="/request-notification-estimation" component={RequestEstimationNotification} />
              <Route path="/request-notification-close" component={RequestCloseNotification} />
              <Route path="/follow-notification" component={FollowingNotification} />

              {/* followers */}

              <Route path="/followers" component={Followers} />
              <Route path="/followers-buyer" component={FollowersBuyer} />
              <Route path="/seller-followers-buyer" component={SellerFollowersBuyer} />
              <Route path="/affiliator-followers-buyer" component={AffiliatorFollowersBuyer} />

              {/* My points */}
              <Route path="/my-points" component={MyPoints} />
              <Route path="/affiliator-my-points" component={AffiliatorMyPoints} />

              {/* Configuration */}

              <Route path="/configuration" component={Configuration} />
              <Route path="/configuration-buyer" component={ConfigurationBuyer} />

            </Switch>
          </Router>

        </Provider>
      </div>
    );
  }
}
// export default withTranslation('login')(App);
// export { App };
export default App;
